module.exports = __webpack_public_path__ + "img/program.39a598c4.svg";